import {Div} from 'components';
import SearchModal from './SearchModal';
// profile
import ChangeEmailScreen from './ProfileScreen/ChangeEmailScreen';
import LoginInfoScreen from './ProfileScreen/LoginInfoScreen';
import ChangePasswordScreen from './ProfileScreen/ChangePasswordScreen';
import ChangeAddressScreen from './ProfileScreen/ChangeAddressScreen';
import OtpRequestModal from 'screens/UnAuthorized/OtpRequestModal';
// account verify
import AccountVerifyScreen from './AccountVerifyScreen';
import AccountInfoModal from './AccountVerifyScreen/AccountInfoModal';
import EditBankInfoModal from './AccountVerifyScreen/EditBankInfoModal';
import EditAccountInfoModal from './AccountVerifyScreen/EditAccountInfoModal';
import EditAddressInfoModal from './AccountVerifyScreen/EditAddressInfoModal';
import BankInfoModal from './AccountVerifyScreen/BankInfoModal';
import AddressInfoModal from './AccountVerifyScreen/AddressInfoModal';
import ConfirmModal from './AccountVerifyScreen/ConfirmModal';
import RiskConfirmModal from './AccountVerifyScreen/RiskConfirmModal';
import AgentcyInfoModal from './AccountVerifyScreen/AgentcyInfoModal';
import EditAgentcyInfoModal from './AccountVerifyScreen/EditAgentcyInfoModal';
// investment manage
// tab
import OverviewScreen from './OverviewScreen';
import TransactionScreen from './TransactionScreen';
import InvestmentScreen from './InvestmentScreen';
import AssetScreen from './AssetScreen';
import ProgramDetailsModal from './AssetScreen/ProgramDetailsModal';
import ListAssetDetailsModal from './AssetScreen/ListAssetDetailsModal';
import ProfileScreen from './ProfileScreen';
// setting screen
import SettingScreen from './SettingScreen';
import SettingLanguageModal from './SettingScreen/SettingLanguageModal';
import DeleteAccountModal from './SettingScreen/DeleteAccountModal';
import ActiveBiometricModal from './SettingScreen/ActiveBiometricModal';
import InvestmentLibraryDetailScreen from './InvestmentLibraryScreen/InvestmentLibraryDetailScreen';
import NotificationScreen from './NotificationScreen';
import SupportScreen from './SupportScreen';
import InvestmentLibraryScreen from './InvestmentLibraryScreen';

// orrder transaction
import AutoInvestOrderDetailsModal from './TransactionScreen/AutoInvestOrderDetailsModal';
import OrderBuyDetailsModal from './TransactionScreen/OrderBuyDetailsModal';
import OrderSellDetailsModal from './TransactionScreen/OrderSellDetailsModal';
import OrderTransferDetailsModal from './TransactionScreen/OrderTransferDetailsModal';
import OrderHistoryDetailsModal from './TransactionScreen/OrderHistoryDetailsModal';
import FilterHistoryModal from './TransactionScreen/FilterHistoryModal';

// reward event
import EventRewardScreen from './EventRewardScreen';
import CreateOrderBuyBountyScreen from './EventRewardScreen/CreateOrderBuyBountyScreen';
import ImageTransactionModal from './EventRewardScreen/ImageTransactionModal';
import IntroductionModal from './EventRewardScreen/IntroductionModal';
import RegulationModal from './EventRewardScreen/RegulationModal';

//invest ment
import InvestmentDetailsScreen from './InvestmentScreen/InvestmentDetailsScreen';
// create order
import CreateOrderModal from './CreateOrderModal';
import TransferContentStepModal from './CreateOrderModal/TransferContentStepModal';
import FeeTableModal from './CreateOrderModal/FeeTableModal';
import OnlineTradingModal from './OnlineTradingModal/OnlineTradingModal';
// digital signaturescreen
// import DigitalSignatureScreen from './DigitalSignature/DigitalSignatureScreen';

import ReviewInfoModal from '../UnAuthorized/ControlEKYCScreen/ReviewInfoModal';
import ControlEKYCScreen from '../UnAuthorized/ControlEKYCScreen';
import ReviewInfoCMNDModal from './ChangeCMNDtoCCCDScreen/ReviewInfoCMNDModal';
import DigitalSignatureChangeCMNDScreen from './ChangeCMNDtoCCCDScreen/DigitalSignatureChangeCMNDScreen';
import ChangeCMNDtoCCCDDetailsScreen from './ChangeCMNDtoCCCDScreen/ChangeCMNDtoCCCDDetailsScreen';
import ControlCMNDScreen from './ChangeCMNDtoCCCDScreen/ControlCMNDScreen';

const screens: any = {
  //   ChatScreen,
  SearchModal,
  // event reward
  EventRewardScreen,
  RegulationModal,
  IntroductionModal,
  ImageTransactionModal,
  CreateOrderBuyBountyScreen,

  //   ProfileScreen,
  ChangeEmailScreen,
  LoginInfoScreen,
  ChangePasswordScreen,
  ChangeAddressScreen,
  OnlineTradingModal,
  //
  OtpRequestModal,
  // accoutn verify
  AccountVerifyScreen,
  AccountInfoModal,
  BankInfoModal,
  AgentcyInfoModal,
  EditAgentcyInfoModal,
  // ProgramDetailsModal,
  EditBankInfoModal,
  EditAddressInfoModal,
  EditAccountInfoModal,
  AddressInfoModal,
  ConfirmModal,
  RiskConfirmModal,
  ReviewInfoModal,
  // setting screen
  SettingScreen,
  DeleteAccountModal,
  SupportScreen,
  SettingLanguageModal,
  ActiveBiometricModal,
  NotificationScreen,
  ListAssetDetailsModal,
  InvestmentLibraryDetailScreen,
  InvestmentLibraryScreen,
  // order transaction
  OrderBuyDetailsModal,
  AutoInvestOrderDetailsModal,
  OrderSellDetailsModal,
  OrderTransferDetailsModal,
  OrderHistoryDetailsModal,
  // FilterHistoryModal,
  ControlEKYCScreen,
  // invest ment
  InvestmentDetailsScreen,
  // create order
  CreateOrderModal,
  TransferContentStepModal,
  FeeTableModal,
  ReviewInfoCMNDModal,
  DigitalSignatureChangeCMNDScreen,
  ChangeCMNDtoCCCDDetailsScreen,
  ControlCMNDScreen,
};

const mainStackScreen = Object.keys(screens)
  .filter(a => !a.includes('modal') && !a.includes('Modal'))
  .map(item => {
    return {
      name: item,
      component: screens?.[item],
    };
  });

const mainStackModal = Object.keys(screens)
  .filter(a => a.includes('modal') || a.includes('Modal'))
  .map(item => {
    return {
      name: item,
      component: screens?.[item],
    };
  });
const mainTab = [
  {
    name: 'OverviewScreen',
    component: OverviewScreen,
  },
  {
    name: 'TransactionScreen',
    component: TransactionScreen,
  },
  {
    name: 'InvestmentScreen',
    component: InvestmentScreen,
  },
  {
    name: 'AssetScreen',
    component: AssetScreen,
  },
  {
    name: 'ProfileScreen',
    component: ProfileScreen,
  },
];

export {mainStackScreen, mainStackModal, mainTab};
